export default __webpack_public_path__ + "static/media/milho_pipoca.3ff211cb.svg";